import React from 'react';
import '../../styles/event.css';
import { choose } from '../../utils/platform';
import { useDashboard } from './useDashboard';
import DashboardDesktop from './Dashboard.desktop';
import { DashboardMobile } from './Dashboard.mobile';

const DashboardView = choose(DashboardDesktop, DashboardMobile);

export default function Dashboard() {
  const vm = useDashboard();
  return <DashboardView vm={vm} />;
}
